import "./CommitteeContent.css";

const CommitteeContent = () => {
  return (
    <>
      <header className="hero">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center hero-content">
              <h1>Committee</h1>
            </div>
          </div>
        </div>
      </header>

      <div className="committee-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3>Chief Patron:</h3>
              <p>Dr. P. Shyama Raju, Chancellor, REVA University, India</p>
              <hr></hr>
              <h3>Patron:</h3>
              <p>Dr. M. Dhanamjaya, Vice-Chancellor, REVA University, India</p>
              <p>
                Dr. Shubha A, Pro Vice-Chancellor (Academics, Governance,
                Training & Placement and IQAC), REVA University, India
              </p>
              <p>
                Dr. R. C. Biradar, Pro Vice-Chancellor, REVA University, India
              </p>
              <p>Dr. N. Ramesh, Registrar, REVA University, India</p>
              <p>Dr.Beena.G, COE, REVA University, India</p>
              <hr></hr>
              <h3>Honorary Chair(s):</h3>
              <p>
                Dr. B. P. Divakar, Dean, R&I Council , REVA Univer-sity, India
              </p>
              <p>
                Dr. Pasupuleti Visweswara Rao, Director, International
                Relations, R&I Council, REVA University, India
              </p>
              <p>
                Dr. Karthik Rajendra, Director, Sponsored Research, R&I Council,
                REVA University, India
              </p>
              <p>
                Dr. Aloknath De, Chair - 2023, IEEE Bangalore Section,
                Bangalore, India
              </p>
              <p>
                Dr. P. Deepa Shenoy , Chair-2022, IEEE Bangalore Section,
                Bangalore, India
              </p>
              <p>
                Mr. Puneet Kumar Mishra, Chair-2021, IEEE Bangalore Section,
                Bangalore, India
              </p>
              <hr></hr>
              <h3>General Chair(s):</h3>
              <p>
                Dr. Senthil. S, Professor & Director, School of Computer Science
                and Applications, REVA University, India
              </p>
              <p>
                Dr. Vishwanath R Hulipalled , Deputy Director R&I Council, REVA
                University, India.
              </p>
              <hr></hr>
              <h3>General Co-Chair:</h3>
              <p>
                Dr. Devanathan.M, IEEE Student Branch Counselor, REVA
                University, India.
              </p>
              <p>
                Dr. Hemanth.K.S, Associate Professor, School of CSA, REVA
                University, India.
              </p>

              <p>
                Dr. Shrikant S Tangade, Past Joint Secretary, IEEE Bangalore
                Section.
              </p>
              <hr></hr>
              <h3>International & National Technical Advisory Committee:</h3>
              <p>Dr. Shivakumara Palaiahnakote, University of Malaya</p>
              <p>Dr. Bryan Gardiner, Ulster University, UK</p>
              <p>Dr. Parthiva Mishra, Principal Scientist, CSIR</p>
              <p>Dr. Heru Suhartanto, University of Indonesia, Indonesia</p>
              <p>
                Dr. Eng. Zdzislaw Polkowski, Professor, University Jana, Poland
              </p>
              <p>
                Dr. Amr Ahmed, Head of School, School of Computer Science,
                University of Nottingham, Malaysia campus, Malaysia
              </p>
              <p>
                Dr. Syed Buhari, Associate Professor (Information Systems
                Audit),School of Business, Universiti Teknologi Brunei, Brunei,
                Darusalam.{" "}
              </p>
              <p>
                Dr. Nilanjan Dey, Associate Professor, Department of Computer
                Science and Engineering, Techno International New Town, Kolkata,
                India
              </p>
              <p>Dr. S.N. Singh, Professor, IIT, Kanpur</p>
              <p>Dr. Udaykumar R. Yaragatti, Director, MNIT, Jaipur</p>
              <p>
                Dr. M. Arunachalam, Retired GM, RPM & SCADA Department, BHEL,
                Bengaluru
              </p>
              <p>
                Dr. Dattatraya Gaonkar, Associate Professor, NITK, Surathkal
              </p>
              <p>Dr. Samarjeet Borah, Professor, SMIT, Sikkim</p>
              <p>Mr. Sudeendra Koushik, IEEE CES, Bangalore, India</p>
              <p>Prof. Dr. Debabrata Das, IIITB, India</p>
              <p>
                Prof. Dr. S. S. Iyengar, Florida International University, USA.
              </p>
              <p>Dr. Anu Kumar Goswami, NIT Silchar</p>
              <p>Dr. Anup Panda, NIT Rourkela</p>
              <p>Dr. Chitti Babu, IIITDM Kancheepuram</p>
              <p>Dr. Bhemappa H, IIIT Sricity</p>
              <hr></hr>
              <h3>Technical Program Committee:</h3>
              <p>
                Dr. Sudharshan K M, Director, School of ECE, REVA University,
                Chair
              </p>
              <p>
                Dr. Mrinal Sarvagya, Professor, School of ECE, REVA University,
                Co-Chair
              </p>
              <p>
                Dr. Ambili.P.S, Associate Professor, school of CSA, REVA
                University Co-Chair
              </p>
              <p>
                Dr.K. Vijaya Lakshmi, Associate Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Dr. Sasikala G, Associate Professor, School of CSA, REVA
                University, India
              </p>
              <p>
                Dr. Manjunath R Kounte, Associate Professor, Head-ECM, School of
                ECE
              </p>
              <p>
                Dr. Ritesh Dash, Associate Professor, school of EEE, REVA
                University
              </p>
              <p>
                Dr. Viswanath Y, Professor, School of CSE, REVA University,
                India
              </p>
              <p>
                Mr. Chengappa, Secretary, IEEE Bangalore Section, Bangalore,
                India
              </p>
              <p>
                Dr. Muthukumar Balasubramanian, Professor, School of CIT, REVA
                University, India
              </p>
              <p>
                Dr. Arun Biradar, Professor, School of CSE, REVA University,
                India
              </p>
              <p>
                Dr Bharati S H, Professor, School of ECE ,REVA University, India
              </p>
              <p>
                Dr. Arunachalam, Professor, School of EEE ,REVA University,
                India
              </p>
              <hr></hr>
              <h3>Publication Committee:</h3>
              <p>
                Dr. M Mallikarjun M Kodabagi, Professor & Deputy Director,
                School of CIT, REVA University, Chair
              </p>
              <p>
                Dr. Venkata Siva Reddy, Professor, School of ECE, REVA
                University, Chair
              </p>
              <p>
                Dr. Rajeev Ranjan, Associate Professor, School of CSA, REVA
                University, India, Co-Chair
              </p>
              <p>
                Dr. Mohammed Riyaz Ahmed, Associate Professor, School of ECE,
                REVA University, Co-Chair
              </p>
              <p>
                Mr. Raghavendra Prasad, Excom, IEEE Bangalore Section, Co-Chair
              </p>
              <p>
                Dr. Vijayalakshmi A Lepakshi , Associate Professor, School of
                CSA, REVA University, India
              </p>
              <p>
                Dr. Lakshmi K , Associate Professor, School of CSA, REVA
                University, India
              </p>
              <p>
                Dr. K Narayan Swamy, Professor, School of EEE ,REVA University,
                India
              </p>
              <p>
                Dr.Uday Murthy, Assoc Prof, School of CIT, REVA University,
                India.
              </p>
              <p>
                Dr. RaviKumar Y B, Assoc Prof, School of CIT, REVA University,
                India
              </p>
              <p>
                Prof. Sowmya Sundari , Asst Prof, School of CIT, REVA
                University, India
              </p>
              <hr></hr>
              <h3>Local Organizing Committee:</h3>
              <p>Dr Raghu C N, Director, School of EEE, Chair</p>
              <p>
                Dr.Vinayaka Murthy.M, Professor, School of CSA, REVA University,
                India, Co-Chair
              </p>
              <p>
                Dr. Thontadari, Assistant Professor, School of CSA, REVA
                University, Co-Chair
              </p>
              <p>
                Dr. Geeta D, Professor, School of CIT, REVA University, India,
                CO-Chair
              </p>
              <p>
                Prof. P I Basarkod, Professor, School of ECE, REVA University,
                India, CO-Chair
              </p>
              <p>
                Dr.Syed Muzamil Basha, Assoc Prof, School of CSE, REVA
                University, India,Co-Chair
              </p>

              <p>
                Prof. R Pinaka Pani, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Vijaya Kumar H, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Dr.Bhaskar Reddy, Professor, School of CSE, REVA University,
                India
              </p>
              <p>
                Prof. Aruna Kumar B , Asst Prof, School of CIT, REVA University,
                India
              </p>
              <hr></hr>
              <h3>Finance Committee:</h3>
              <p>
                Mr. Vasu, DGM Accounts & Finance , REVA University, India, Chair
              </p>
              <p>
                Prof.Lokesh.C.K, Assistant Professor, School of CSA, REVA
                University, India. Co-Chair
              </p>
              <p>
                Prof.Deepa, Assistant Professor,School of CSA, REVA University,
                India, Co-Chair
              </p>
              <p>Mr. P V Swamy, Accounts, REVA University, India, Co–Chair</p>
              <p>
                Dr. Abhishek M. Appaji, Excom, Treasurer, IEEE Bangalore Section
              </p>
              <hr></hr>
              <h3>Website Chairs</h3>
              <p>
                Dr. Ashwin Kumar U M, Deputy Director, School of CSE ,REVA
                University, Chair
              </p>
              <p>
                Prof. Pavankumar Naik , Asst Prof, School of CIT, REVA
                University, India, Co-Chair
              </p>
              <p>
                Prof.Nagaraju .S, Assistant Professor, School of CSA, REVA
                University, India, Co-Chair
              </p>
              <hr></hr>
              <h3>Organizing Chairs</h3>
              <p>
                Dr.Devi A , Associate Professor, School of CSA, REVA University,
                India
              </p>
              <p>
                Dr. A P Bhuveneswari , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Dr. Deeba K, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Ravi Dandu, Assistant Professor, School of CSA, REVA
                University, India.{" "}
              </p>
              <p>
                Prof. Vijayalaxmi. P. Chiniwar , Assistant Professor, School of
                CSA, REVA University, India.
              </p>
              <p>
                Prof. Vidya S , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Krishnamurthy R, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Md Abdul Khader Jailani , Assistant Professor, School of
                CSA, REVA University, India.
              </p>
              <p>
                Prof. P Sree Lakshmi ,Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Shreetha Bhat , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof.Sneha N , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Vinay G , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof.Abhay Kumar Srivastav , Assistant Professor, School of CSA,
                REVA University, India.
              </p>
              <p>
                Prof.Aryamol, Assistant Professor, School of CSA, REVA
                University, India.
              </p>

              <p>
                Prof.Aditya V, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Manju B, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Jesla, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Komala R, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Pradeepa D, Assistant Professor, School of CSA, REVA
                University, India.
              </p>

              <p>
                Prof. Anjali Surendran, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Manjunath B , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Anitha Rani K S , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Archana Bhaskar , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Farhanaaz , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. B Hemalatha , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Rajib Guha Thakurta , Assistant Professor, School of CSA,
                REVA University, India.
              </p>
              <p>
                Prof. Mohammed Mueen Pasha , Assistant Professor, School of CSA,
                REVA University, India.
              </p>
              <p>
                Prof. Sowmya P D, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Divyashree D , Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <p>
                Prof. Sheela D V, Assistant Professor, School of CSA, REVA
                University, India.
              </p>
              <hr></hr>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommitteeContent;
